import { GATag } from '@domgen/dgx-fe-ga';

import {
  CustomerDetails,
  RegisteredItem,
  RegisteredItemProductDetails,
  RegistrationApplianceDetails,
  RegistrationRequest,
} from '@us-registration/util-models';

export function formatRegistrationStoredTags(
  registrationCustomerDetails: CustomerDetails,
  registeredItem: RegisteredItem,
  codeUsed: string | null
): GATag {
  const appliance: RegistrationApplianceDetails = registeredItem.appliances[0];
  const product: RegisteredItemProductDetails = registeredItem.products[0];

  return {
    event: 'registrationStored',
    quoteId: registeredItem.Id,
    brand: registeredItem.merchandiseBrand,
    dateOfPurchase: appliance.purchaseDate,
    modelNumber: 'provided',
    modelNumberDetail: appliance.modelNumber,
    multiRegTotal: 1,
    retailer: registeredItem.merchandiseManufacturer,
    offerPrice: product.price,
    offerStatus: 1,
    productName: appliance.type,
    purchaseCost: appliance.purchasePrice,
    registrationsStored: 1,
    serialNumber: 'provided',
    serialNumberDetail: appliance.serialNumber,
    codeUsed: codeUsed,
    address: {
      addressLine1: 'provided',
      addressLine2: registrationCustomerDetails.billingAddress.line2
        ? 'provided'
        : 'not-provided',
      addressLine3: 'not-provided',
      addressLine4: registrationCustomerDetails.billingAddress.city,
      countryCode: 'provided',
      countryIso2: 'provided',
      countryIso3: 'provided',
      countryIsoNumber: 'provided',
      countryName: 'provided',
      id: 'provided',
      postalCode: 'provided',
      type: 'provided',
    },
    email: { main: 'provided' },
    firstName: 'provided',
    marketingPreferences: { email: 'provided', telephone: 'provided' },
    preferredContactMethod: 'provided',
    sendMethod: 'provided',
    surname: 'provided',
    telephoneDetails: { home: 'provided', mobile: 'provided' },
  };
}

export function formatRegistrationStoredTagsNoOffer(
  registrationRequest: RegistrationRequest,
  codeUsed: string | null
): GATag {
  const appliance: RegistrationApplianceDetails =
    registrationRequest.merchandise[0];
  const customerDetails: CustomerDetails = registrationRequest.customer;

  return {
    event: 'registrationStored',
    quoteId: 'not-available',
    brand: appliance.brand,
    dateOfPurchase: appliance.purchaseDate,
    modelNumber: 'provided',
    modelNumberDetail: appliance.modelNumber,
    multiRegTotal: 1,
    retailer: appliance.brand,
    offerPrice: 'not-available',
    offerStatus: 0,
    productName: appliance.type,
    purchaseCost: appliance.purchasePrice,
    registrationsStored: 1,
    serialNumber: 'provided',
    serialNumberDetail: appliance.serialNumber,
    codeUsed: codeUsed,
    address: {
      addressLine1: 'provided',
      addressLine2: customerDetails.billingAddress.line2
        ? 'provided'
        : 'not-provided',
      addressLine3: 'not-provided',
      addressLine4: customerDetails.billingAddress.city,
      countryCode: 'provided',
      countryIso2: 'provided',
      countryIso3: 'provided',
      countryIsoNumber: 'provided',
      countryName: 'provided',
      id: 'provided',
      postalCode: 'provided',
      type: 'provided',
    },
    email: { main: 'provided' },
    firstName: 'provided',
    marketingPreferences: { email: 'provided', telephone: 'provided' },
    preferredContactMethod: 'provided',
    sendMethod: 'provided',
    surname: 'provided',
    telephoneDetails: { home: 'provided', mobile: 'provided' },
  };
}
